module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("List of Genealogical Tables")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "f_fig"
  }, [_vm._v("I.")]), _vm._v(" The Family of Antipater")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "f_fig"
  }, [_vm._v("II.")]), _vm._v(" The Family of Antipater’s Eldest Daughter")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "f_fig"
  }, [_vm._v("III.")]), _vm._v(" The Family of Nikaia")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "f_fig"
  }, [_vm._v("IV.")]), _vm._v(" The Families of Eurydike and Berenike")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "f_fig"
  }, [_vm._v("V.")]), _vm._v(" The Families of Phila")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "f_fig"
  }, [_vm._v("VI.")]), _vm._v(" The Macedonian Kings, 359–239")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-723f149a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_table.vue
// module id = 72
// module chunks = 0